<template>
  <div class="client-item-box new-line" :id="'nofixNav'+data.nofixNavId+'-'+data.nofixNavIndex" :data-trackdata="tData">
    <div class="new-line-box" :style="{'height': `${lineHeight}px`, 'background': `${data.lineColor}`}"></div>
  </div>
</template>

<script>

import { getClientWidth } from '../lib/util.js'

const clientWidth = getClientWidth()
const ratio = clientWidth/375

export default {
  name: 'line',
  props: ['data'],
  data () {
    return {
      pl: 0,
      pr: 0,
      pt: 0,
      pb: 0,
      lineHeight: 0,
      tData: JSON.stringify(this.data.trackData || {})
    }
  },
  components: {
  },
  mounted () {
  },
  created () {
    this.formatData()
  },
  computed: {
    // styleObj () {
    //   return {
    //     'padding-left': `${ratio*this.pl}px`,
    //     'padding-right': `${ratio*this.pr}px`,
    //     'padding-top': `${ratio*this.pt}px`,
    //     'padding-bottom': `${ratio*this.pb}px`
    //   }
    // }
  },
  methods: {
    formatData() {
      // const pl = this.data.leftPadding?Number(this.data.leftPadding):0
      // const pr = this.data.rightPadding?Number(this.data.rightPadding):0
      // const pt = this.data.topPadding?Number(this.data.topPadding):0
      // const pb = this.data.bottomPadding?Number(this.data.bottomPadding):0
      // this.pl = pl
      // this.pr = pr
      // this.pt = pt
      // this.pb = pb

      this.lineHeight = this.data.lineHeight?Number(this.data.lineHeight)*ratio:0
    }
  }
}
</script>



// WEBPACK FOOTER //
// new-line.vue?c228448e